import invoiceModule from '../module'
import invoiceBalanceDialog from '../view/invoiceBalance.html'
/**
 * 是否可以差额
 * @param  {object} bindings 组件的绑定对象
 * @return {string}          错误信息
 */
function canBalance(bindings) {
    const { invoice } = bindings
    if (invoice.details.length === 0) {
        return '请先添加商品行'
    }
    const { selectedRows } = bindings
    // 是否选中行
    if (selectedRows.length === 0) {
        return '请先选择商品行'
    }
    if (invoice.details.length > 1) {
        return '正常商品明细行超过1行，不能添加差额'
    }
    // 待差额的商品行
    const goodsToBalance = invoice.details[0]
    // 税率为减按1.5%的发票不能差额
    if (goodsToBalance.taxRate === 0.015) {
        return '税率为减按1.5%的发票不能差额'
    }
    const reg = goodsToBalance.isRed ? /^-\d{1,12}(\.\d{0,2})?$/ : /^\d{1,12}(\.\d{0,2})?$/
    if (!reg.test(goodsToBalance.amount)) {
        return '请填写正确的商品金额'
    }
    return ''
}

/**
 * 差额弹窗controller
 */
class modalBalanceCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, globalFn) {
        $scope.modaldata = items1
        if (!$scope.modaldata.balance) {
            $scope.modaldata.balance = ''
        }
        $scope.balanceChange = function balanceChange() {
            if (!$scope.modaldata.balance) {
                $scope.modaldata.balance = ''
                return
            }

            if ($scope.modaldata.isRed === '0' && !globalFn.isPositiveFloatNum($scope.modaldata.balance)) {
                $scope.modaldata.balance = ''
                logger.logError('扣除额格式错误！')
                return
            }
            if ($scope.modaldata.isRed === '1' && !globalFn.isNegativeFloatNum($scope.modaldata.balance)) {
                $scope.modaldata.balance = ''
                logger.logError('扣除额格式错误！')
                return
            }
            let balance
            if ($scope.modaldata.isRed === '0') {
                balance = globalFn.cutOutPnumber($scope.modaldata.balance, 2)
            } else {
                balance = globalFn.cutOutNnumber($scope.modaldata.balance, 2)
            }
            $scope.modaldata.balance = parseFloat(balance).toFixed(2)
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok() {
            // 返回数据
            if ($scope.modaldata.isRed === '0') {
                if ($scope.modaldata.balance === '' || $scope.modaldata.balance === undefined || $scope.modaldata.balance === null) {
                    logger.logError('请输入扣除额！')
                } else if (!globalFn.isPositiveFloatNum($scope.modaldata.balance)) {
                    logger.logError('扣除额格式错误！')
                } else if (globalFn.Sub($scope.modaldata.amount, $scope.modaldata.balance) <= 0 || globalFn.Sub($scope.modaldata.balance, 0) <= 0) {
                    logger.logError('扣除额小于商品不含税金额且大于0！')
                } else {
                    $uibModalInstance.close($scope.modaldata)
                }
            } else {
                if ($scope.modaldata.balance === '' || $scope.modaldata.balance === undefined || $scope.modaldata.balance === null) {
                    logger.logError('请输入扣除额！')
                    return
                } if (!globalFn.isNegativeFloatNum($scope.modaldata.balance)) {
                    logger.logError('扣除额格式错误！')
                    return
                } if (globalFn.Sub($scope.modaldata.amount, $scope.modaldata.balance) >= 0 || globalFn.Sub($scope.modaldata.balance, 0) >= 0) {
                    logger.logError('扣除额大于商品不含税金额且小于0！')
                    return
                }
                $uibModalInstance.close($scope.modaldata)
            }
        }
    }
}

modalBalanceCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'globalFn']

invoiceModule.controller('modalBalanceCtrl', modalBalanceCtrl)
invoiceModule.component('invoiceBalance', {
    bindings: {
        invoice: '<',
        selectedRows: '<',
    },
    template: `
    <button class="btn btn-default btn-xs" ng-class="{'btn-disabled': ctrl.invoice.isList === '1'}"
        ng-click="ctrl.openBalanceDialog()">差额
    </button>
    `,
    controllerAs: 'ctrl',
    controller: ['logger', '$uibModal', function ctrl(logger, $uibModal) {
        const bindings = this
        this.openBalanceDialog = function openBalanceDialog() {
            if (bindings.invoice.isList === '1') {
                return
            }
            const { invoice } = bindings
            const errorMsg = canBalance(bindings)
            if (errorMsg) {
                logger.logError(errorMsg)
                return
            }
            // 被差额的商品行
            const goodsToBalance = invoice.details[0]
            // 弹窗
            const balanceModalData = {
                amount: goodsToBalance.amount,
                balance: goodsToBalance.balance,
                isRed: invoice.isRed,
            } // 数据
            const modalInstance = $uibModal.open({
                template: invoiceBalanceDialog,
                controller: 'modalBalanceCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                resolve: {
                    items1() {
                        return balanceModalData
                    },
                },
            })
            modalInstance.result.then((item) => {
                goodsToBalance.$balance = item.balance
                // 蓝票
                if (invoice.isRed !== '1') {
                    invoice.remark = `差额征税：${item.balance}。`
                } else {
                    let remark = ''
                    if (invoice.remark.indexOf('差额征税。') === -1) {
                        remark = '差额征税。'
                    }
                    invoice.remark = remark + invoice.remark
                }
            })
        }
    }],
})



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/invoiceBalance.js